import React from "react";

/**
 * Fired after a successful location geocode. The argument is the resolved
 * location's `formatted_address`, used as the debounce key so the survey only
 * re-runs when the searched location actually changes.
 */
export type SurveyTrigger = (searchedLocation?: string) => void;

export const noopSurveyTrigger: SurveyTrigger = () => {};

/**
 * Bridges the retail locator's location-change event to the survey modal, which
 * is a sibling in the component tree. `RetailLocatorSSR` owns the underlying
 * ref; `StoreLocatorSurvey` registers its handler and `RetailLocatorBlock`
 * consumes this context to fire it.
 */
export const SurveyTriggerContext =
    React.createContext<SurveyTrigger>(noopSurveyTrigger);

export const useSurveyTrigger = (): SurveyTrigger =>
    React.useContext(SurveyTriggerContext);
